module.exports = __webpack_public_path__ + "static/media/quick_sword.e11c205f.png";